<template>
    <div class="bax-banner-content d-flex align-items-end pb-0">
        <div class="container bax-wide">
            <div class="bax-tab-wrap">
                <div class="tabs d-md-flex justify-content-md-between">
                    <div
                        v-for="(step, index) in steps"
                        :key="index"
                        data-v-46c7b794=""
                        class="tab-button"
                        v-bind:class="
                            [
                                (active == step.label ? 'tab-active' : ''),
                                (step.label < active ? 'tab-complete' : '')
                            ]
                        "
                    >
                        <a>
                            <span data-v-46c7b794="" class="tab-label">
                                Step {{ step.label }}
                            </span>
                            <span data-v-46c7b794="" class="tab-name">{{ step.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CsvOrderSteps',
    props: {
        active: {
            required: true,
        },
        data() {
            return {
                open: false,
                randId: '',
                onHold: false,
            };
        },

    },
    data() {
        return {
            steps: [
                {
                    label: 1,
                    name: 'Upload File',
                },
                {
                    label: 2,
                    name: 'Processing Upload',
                },
                {
                    label: 3,
                    name: 'Make Substitutions',
                },
                {
                    label: 4,
                    name: 'Review Orders',
                },
                {
                    label: 5,
                    name: 'Submit Orders',
                },
            ],
        };
    },
    mounted() {
        //
    },
};
</script>
